/**
 * Homepage content - Multilingual translations (EN/FR/ES/AR)
 */

export type SupportedLang = 'en' | 'fr' | 'es' | 'ar' | 'de' | 'it' | 'pt' | 'nl' | 'pl' | 'ru' | 'zh' | 'ja' | 'tr' | 'ko' | 'sv' | 'da' | 'hi' | 'ro' | 'cs' | 'hu' | 'fi' | 'th' | 'vi' | 'el' | 'no' | 'id' | 'ms' | 'tl' | 'bn';

export const homeContent = {
  hero: {
    en: {
      badge: '#1 Global Tech & Support Talent Ecosystem',
      h1: "The Limitless Tech & Support Talent Ecosystem — BPO, Digital Factory & Freelancers",
      sub: '500+ agents, 29 languages, 200+ enterprise clients. Dedicated teams or vetted freelancers — same platform, same quality.',
      ctaPrimary: 'Start Free Week',
      ctaSecondary: 'Order BPO Services',
      trustBadge: 'First week free • No credit card • Cancel anytime',
      microProof: [
        '24/7/365 coverage',
        'Multilingual teams (EN/FR/ES/AR + 17 more)',
        '50-70% savings vs Western Europe/USA',
        'Go live in 7 days',
        'ISO 27001 • GDPR • PCI-DSS aligned',
      ],
      proofMetrics: [
        { value: '200+', label: 'Clients' },
        { value: '500+', label: 'Agents' },
        { value: '29', label: 'Languages' },
        { value: '95%+', label: 'CSAT' },
        { value: '99.9%', label: 'SLA Uptime' },
        { value: '50-70%', label: 'Cost Savings' },
        { value: '7 Days', label: 'Deployment' },
      ],
      trustedBy: 'Trusted by 200+ companies worldwide',
      dialogTitle: 'Schedule a Discovery Call',
    },
    fr: {
      badge: 'N°1 Écosystème de Talents Tech & Support',
      h1: 'L\'Écosystème de Talents Tech & Support Sans Limite — BPO, Digital Factory & Freelances',
      sub: 'BPO multilingue 24/7 + Marketplace freelance : équipes dédiées ou talents indépendants — même plateforme, même qualité.',
      ctaPrimary: 'Semaine d\'essai gratuite',
      ctaSecondary: 'Commander des services BPO',
      trustBadge: 'Première semaine gratuite • Sans carte bancaire • Annulable à tout moment',
      microProof: [
        'Couverture 24/7/365',
        'Équipes multilingues (FR/EN/ES/AR + 8 autres)',
        '50-70% d\'économies vs Europe/USA',
        'Déploiement en 7 jours',
        'ISO 27001 • RGPD • PCI-DSS',
      ],
      proofMetrics: [
        { value: '200+', label: 'Clients' },
        { value: '500+', label: 'Agents' },
        { value: '29', label: 'Langues' },
        { value: '95%+', label: 'CSAT' },
        { value: '99.9%', label: 'SLA Uptime' },
        { value: '50-70%', label: 'Économies' },
        { value: '7 Jours', label: 'Déploiement' },
      ],
      trustedBy: 'La confiance de plus de 200 entreprises dans le monde',
      dialogTitle: 'Planifier un appel de découverte',
    },
    es: {
      badge: 'N°1 Ecosistema de Talento Tech & Soporte',
      h1: 'El Ecosistema de Talento Tech & Soporte Sin Límites — BPO, Fábrica Digital & Freelancers',
      sub: 'BPO multilingüe 24/7 + Marketplace freelance: equipos dedicados o talento independiente — misma plataforma, misma calidad.',
      ctaPrimary: 'Semana de prueba gratis',
      ctaSecondary: 'Pedir servicios BPO',
      trustBadge: 'Primera semana gratis • Sin tarjeta • Cancela en cualquier momento',
      microProof: [
        'Cobertura 24/7/365',
        'Equipos multilingües (ES/EN/FR/AR + 8 más)',
        '50-70% ahorro vs Europa/USA',
        'Despliegue en 7 días',
        'ISO 27001 • RGPD • PCI-DSS',
      ],
      proofMetrics: [
        { value: '200+', label: 'Clientes' },
        { value: '500+', label: 'Agentes' },
        { value: '29', label: 'Idiomas' },
        { value: '95%+', label: 'CSAT' },
        { value: '99.9%', label: 'SLA Uptime' },
        { value: '50-70%', label: 'Ahorro' },
        { value: '7 Días', label: 'Despliegue' },
      ],
      trustedBy: 'Más de 200 empresas confían en nosotros',
      dialogTitle: 'Agenda una llamada de descubrimiento',
    },
    ar: {
      badge: 'منظومة المواهب التقنية والدعم العالمية',
      h1: 'منظومة المواهب التقنية والدعم بلا حدود — BPO، المصنع الرقمي والمستقلين',
      sub: 'خدمات BPO متعددة اللغات 24/7 + سوق المستقلين: فرق مخصصة أو مواهب مستقلة — نفس المنصة، نفس الجودة.',
      ctaPrimary: 'ابدأ الأسبوع المجاني',
      ctaSecondary: 'اطلب خدمات BPO',
      trustBadge: 'الأسبوع الأول مجاني • بدون بطاقة ائتمان • إلغاء في أي وقت',
      microProof: [
        'تغطية 24/7/365',
        'فرق متعددة اللغات (AR/FR/EN/ES + 8 أخرى)',
        'وفر 50-70% مقارنة بأوروبا/أمريكا',
        'إطلاق خلال 7 أيام',
        'ISO 27001 • GDPR • PCI-DSS',
      ],
      proofMetrics: [
        { value: '+200', label: 'عملاء' },
        { value: '+500', label: 'وكيل' },
        { value: '29', label: 'لغة' },
        { value: '+95%', label: 'CSAT' },
        { value: '99.9%', label: 'SLA' },
        { value: '50-70%', label: 'توفير' },
        { value: '7 أيام', label: 'إطلاق' },
      ],
      trustedBy: 'موثوق من أكثر من 200 شركة حول العالم',
      dialogTitle: 'جدولة مكالمة استكشافية',
    },
    de: {
      badge: 'Nr.1 Globales Talent-Ökosystem',
      h1: 'Das grenzenlose Tech- & Support-Talent-Ökosystem — BPO, Digital Factory & Freelancer',
      sub: '24/7 mehrsprachiges BPO + Freelancer-Marktplatz: dedizierte Teams oder unabhängige Talente — gleiche Plattform, gleiche Qualität.',
      ctaPrimary: 'Kostenlose Testwoche starten',
      ctaSecondary: 'BPO-Services bestellen',
      trustBadge: 'Erste Woche kostenlos • Keine Kreditkarte • Jederzeit kündbar',
      microProof: ['24/7/365 Abdeckung', 'Mehrsprachige Teams (DE/EN/FR/ES + 8 weitere)', '50-70% Einsparung vs. Europa/USA', 'Go-Live in 7 Tagen', 'ISO 27001 • DSGVO • PCI-DSS'],
      proofMetrics: [{ value: '200+', label: 'Kunden' }, { value: '500+', label: 'Agenten' }, { value: '29', label: 'Sprachen' }, { value: '95%+', label: 'CSAT' }, { value: '99.9%', label: 'SLA' }, { value: '50-70%', label: 'Einsparung' }, { value: '7 Tage', label: 'Deployment' }],
      trustedBy: 'Vertraut von 200+ Unternehmen weltweit',
      dialogTitle: 'Entdeckungsgespräch buchen',
    },
    it: {
      badge: 'N°1 Ecosistema Globale di Talenti',
      h1: 'L\'Ecosistema di Talenti Tech & Supporto Senza Limiti — BPO, Digital Factory & Freelancer',
      sub: 'BPO multilingue 24/7 + Marketplace freelance: team dedicati o talenti indipendenti — stessa piattaforma, stessa qualità.',
      ctaPrimary: 'Inizia la settimana gratuita',
      ctaSecondary: 'Ordina servizi BPO',
      trustBadge: 'Prima settimana gratuita • Senza carta di credito • Cancella quando vuoi',
      microProof: ['Copertura 24/7/365', 'Team multilingue (IT/EN/FR/ES + 8 altri)', '50-70% risparmio vs Europa/USA', 'Go-live in 7 giorni', 'ISO 27001 • GDPR • PCI-DSS'],
      proofMetrics: [{ value: '200+', label: 'Clienti' }, { value: '500+', label: 'Agenti' }, { value: '29', label: 'Lingue' }, { value: '95%+', label: 'CSAT' }, { value: '99.9%', label: 'SLA' }, { value: '50-70%', label: 'Risparmio' }, { value: '7 Giorni', label: 'Deployment' }],
      trustedBy: 'Scelto da oltre 200 aziende nel mondo',
      dialogTitle: 'Prenota una chiamata esplorativa',
    },
    pt: {
      badge: 'N°1 Ecossistema Global de Talentos',
      h1: 'O Ecossistema de Talentos Tech & Suporte Sem Limites — BPO, Fábrica Digital & Freelancers',
      sub: 'BPO multilíngue 24/7 + Marketplace freelance: equipes dedicadas ou talentos independentes — mesma plataforma, mesma qualidade.',
      ctaPrimary: 'Comece a semana grátis',
      ctaSecondary: 'Encomendar serviços BPO',
      trustBadge: 'Primeira semana grátis • Sem cartão de crédito • Cancele a qualquer momento',
      microProof: ['Cobertura 24/7/365', 'Equipes multilíngues (PT/EN/FR/ES + 8 mais)', '50-70% economia vs Europa/EUA', 'Go-live em 7 dias', 'ISO 27001 • GDPR • PCI-DSS'],
      proofMetrics: [{ value: '200+', label: 'Clientes' }, { value: '500+', label: 'Agentes' }, { value: '29', label: 'Idiomas' }, { value: '95%+', label: 'CSAT' }, { value: '99.9%', label: 'SLA' }, { value: '50-70%', label: 'Economia' }, { value: '7 Dias', label: 'Implantação' }],
      trustedBy: 'Confiado por mais de 200 empresas no mundo',
      dialogTitle: 'Agendar uma chamada de descoberta',
    },
    nl: {
      badge: 'Nr. 1 Globaal Talent Ecosysteem',
      h1: 'Het Grenzeloze Tech- & Support-Talent-Ecosysteem — BPO, Digital Factory & Freelancers',
      sub: '24/7 meertalige BPO + Freelancer-marktplaats: toegewijde teams of onafhankelijk talent — zelfde platform, zelfde kwaliteit.',
      ctaPrimary: 'Start gratis proefweek',
      ctaSecondary: 'BPO-diensten bestellen',
      trustBadge: 'Eerste week gratis • Geen creditcard • Altijd opzegbaar',
      microProof: ['24/7/365 dekking', 'Meertalige teams (NL/EN/FR/ES + 8 meer)', '50-70% besparing vs Europa/VS', 'Go-live in 7 dagen', 'ISO 27001 • GDPR • PCI-DSS'],
      proofMetrics: [{ value: '200+', label: 'Klanten' }, { value: '500+', label: 'Agenten' }, { value: '29', label: 'Talen' }, { value: '95%+', label: 'CSAT' }, { value: '99.9%', label: 'SLA' }, { value: '50-70%', label: 'Besparing' }, { value: '7 Dagen', label: 'Deployment' }],
      trustedBy: 'Vertrouwd door 200+ bedrijven wereldwijd',
      dialogTitle: 'Ontdekkingsgesprek boeken',
    },
    pl: {
      badge: 'Nr 1 Globalny Ekosystem Talentów',
      h1: 'Ekosystem Talentów Tech & Wsparcia Bez Granic — BPO, Digital Factory & Freelancerzy',
      sub: 'Wielojęzyczne BPO 24/7 + Marketplace freelance: dedykowane zespoły lub niezależni eksperci — ta sama platforma, ta sama jakość.',
      ctaPrimary: 'Rozpocznij darmowy tydzień',
      ctaSecondary: 'Zamów usługi BPO',
      trustBadge: 'Pierwszy tydzień gratis • Bez karty kredytowej • Anuluj w dowolnym momencie',
      microProof: ['Pokrycie 24/7/365', 'Wielojęzyczne zespoły (PL/EN/FR/ES + 8 więcej)', '50-70% oszczędności vs Europa/USA', 'Start w 7 dni', 'ISO 27001 • RODO • PCI-DSS'],
      proofMetrics: [{ value: '200+', label: 'Klientów' }, { value: '500+', label: 'Agentów' }, { value: '29', label: 'Języki' }, { value: '95%+', label: 'CSAT' }, { value: '99.9%', label: 'SLA' }, { value: '50-70%', label: 'Oszczędności' }, { value: '7 Dni', label: 'Wdrożenie' }],
      trustedBy: 'Zaufanie ponad 200 firm na świecie',
      dialogTitle: 'Zarezerwuj rozmowę odkrywczą',
    },
    ru: {
      badge: '№1 Глобальная Экосистема Талантов',
      h1: 'Экосистема Tech- и Support-Талантов Без Границ — BPO, Digital Factory и Фрилансеры',
      sub: 'Многоязычный BPO 24/7 + Маркетплейс фрилансеров: выделенные команды или независимые эксперты — одна платформа, одно качество.',
      ctaPrimary: 'Начать бесплатную неделю',
      ctaSecondary: 'Заказать BPO-услуги',
      trustBadge: 'Первая неделя бесплатно • Без карты • Отмена в любое время',
      microProof: ['Покрытие 24/7/365', 'Многоязычные команды (RU/EN/FR/ES + 8 других)', '50-70% экономия vs Европа/США', 'Запуск за 7 дней', 'ISO 27001 • GDPR • PCI-DSS'],
      proofMetrics: [{ value: '200+', label: 'Клиентов' }, { value: '500+', label: 'Агентов' }, { value: '29', label: 'Языки' }, { value: '95%+', label: 'CSAT' }, { value: '99.9%', label: 'SLA' }, { value: '50-70%', label: 'Экономия' }, { value: '7 Дней', label: 'Запуск' }],
      trustedBy: 'Доверяют более 200 компаний по всему миру',
      dialogTitle: 'Запланировать ознакомительный звонок',
    },
    zh: {
      badge: '全球人才生态系统第一',
      h1: '无限的技术与支持人才生态系统 — BPO、数字工厂与自由职业者',
      sub: '24/7多语言BPO + 自由职业者市场：专属团队或独立人才 — 同一平台，同等品质。',
      ctaPrimary: '开始免费试用周',
      ctaSecondary: '订购BPO服务',
      trustBadge: '首周免费 • 无需信用卡 • 随时取消',
      microProof: ['24/7/365全覆盖', '多语言团队（中/英/法/西 + 8种更多）', '比欧美节省50-70%', '7天上线', 'ISO 27001 • GDPR • PCI-DSS'],
      proofMetrics: [{ value: '200+', label: '客户' }, { value: '500+', label: '坐席' }, { value: '29', label: '语言' }, { value: '95%+', label: 'CSAT' }, { value: '99.9%', label: 'SLA' }, { value: '50-70%', label: '节省' }, { value: '7天', label: '部署' }],
      trustedBy: '全球200+企业的信赖之选',
      dialogTitle: '预约探索性通话',
    },
    ja: {
      badge: 'No.1 グローバル人材エコシステム',
      h1: '無限のテック＆サポート人材エコシステム — BPO、デジタルファクトリー＆フリーランス',
      sub: '24時間多言語BPO + フリーランスマーケットプレイス：専属チームまたは独立人材 — 同じプラットフォーム、同じ品質。',
      ctaPrimary: '無料トライアル週間を開始',
      ctaSecondary: 'BPOサービスを注文',
      trustBadge: '初週無料 • クレジットカード不要 • いつでもキャンセル可能',
      microProof: ['24/7/365カバレッジ', '多言語チーム（日/英/仏/西 + 8言語）', '欧米比50-70%コスト削減', '7日で稼働開始', 'ISO 27001 • GDPR • PCI-DSS'],
      proofMetrics: [{ value: '200+', label: 'クライアント' }, { value: '500+', label: 'エージェント' }, { value: '29', label: '言語' }, { value: '95%+', label: 'CSAT' }, { value: '99.9%', label: 'SLA' }, { value: '50-70%', label: 'コスト削減' }, { value: '7日', label: '展開' }],
      trustedBy: '世界中の200社以上に信頼されています',
      dialogTitle: 'ディスカバリーコールを予約',
    },
    tr: {
      badge: 'No.1 Küresel Yetenek Ekosistemi',
      h1: 'Sınırsız Tech & Destek Yetenek Ekosistemi — BPO, Dijital Fabrika & Freelancerlar',
      sub: '7/24 çok dilli BPO + Freelancer pazaryeri: özel ekipler veya bağımsız yetenekler — aynı platform, aynı kalite.',
      ctaPrimary: 'Ücretsiz deneme haftası başlat',
      ctaSecondary: 'BPO hizmetleri sipariş et',
      trustBadge: 'İlk hafta ücretsiz • Kredi kartı gerekmez • İstediğiniz zaman iptal edin',
      microProof: ['7/24/365 kapsama', 'Çok dilli ekipler (TR/EN/FR/ES + 8 daha)', 'Avrupa/ABD\'ye göre %50-70 tasarruf', '7 günde devreye alım', 'ISO 27001 • KVKK • PCI-DSS'],
      proofMetrics: [{ value: '200+', label: 'Müşteri' }, { value: '500+', label: 'Ajan' }, { value: '29', label: 'Diller' }, { value: '%95+', label: 'CSAT' }, { value: '%99.9', label: 'SLA' }, { value: '%50-70', label: 'Tasarruf' }, { value: '7 Gün', label: 'Kurulum' }],
      trustedBy: 'Dünya genelinde 200+ şirket tarafından güveniliyor',
      dialogTitle: 'Keşif görüşmesi planla',
    },
    ko: {
      badge: '글로벌 1위 인재 생태계',
      h1: '무한한 Tech & 지원 인재 생태계 — BPO, 디지털 팩토리 & 프리랜서',
      sub: '24/7 다국어 BPO + 프리랜서 마켓플레이스: 전담 팀 또는 독립 전문가 — 같은 플랫폼, 같은 품질.',
      ctaPrimary: '무료 체험 주간 시작',
      ctaSecondary: 'BPO 서비스 주문',
      trustBadge: '첫 주 무료 • 신용카드 불필요 • 언제든 취소 가능',
      microProof: ['24/7/365 커버리지', '다국어 팀 (한/영/불/서 + 8개 더)', '유럽/미국 대비 50-70% 절감', '7일 만에 런칭', 'ISO 27001 • GDPR • PCI-DSS'],
      proofMetrics: [{ value: '200+', label: '고객사' }, { value: '500+', label: '에이전트' }, { value: '29', label: '언어' }, { value: '95%+', label: 'CSAT' }, { value: '99.9%', label: 'SLA' }, { value: '50-70%', label: '절감' }, { value: '7일', label: '배포' }],
      trustedBy: '전 세계 200개 이상 기업이 신뢰합니다',
      dialogTitle: '디스커버리 콜 예약',
    },
    sv: {
      badge: 'Nr 1 Globalt Talangekosystem',
      h1: 'Det Gränslösa Tech- & Support-Talangekosystemet — BPO, Digital Factory & Freelancers',
      sub: '24/7 flerspråkig BPO + Freelancer-marknadsplats: dedikerade team eller oberoende talanger — samma plattform, samma kvalitet.',
      ctaPrimary: 'Starta gratis provvecka',
      ctaSecondary: 'Beställ BPO-tjänster',
      trustBadge: 'Första veckan gratis • Inget kreditkort • Avbryt när som helst',
      microProof: ['24/7/365 täckning', 'Flerspråkiga team (SV/EN/FR/ES + 8 fler)', '50-70% besparing vs Europa/USA', 'Go-live på 7 dagar', 'ISO 27001 • GDPR • PCI-DSS'],
      proofMetrics: [{ value: '200+', label: 'Kunder' }, { value: '500+', label: 'Agenter' }, { value: '29', label: 'Språk' }, { value: '95%+', label: 'CSAT' }, { value: '99.9%', label: 'SLA' }, { value: '50-70%', label: 'Besparing' }, { value: '7 Dagar', label: 'Driftsättning' }],
      trustedBy: 'Betrodd av 200+ företag världen över',
      dialogTitle: 'Boka ett upptäcktssamtal',
    },
    da: {
      badge: 'Nr. 1 Globalt Talentøkosystem',
      h1: 'Det Grænseløse Tech- & Support-Talentøkosystem — BPO, Digital Factory & Freelancers',
      sub: '24/7 flersproget BPO + Freelancer-markedsplads: dedikerede teams eller uafhængige talenter — samme platform, samme kvalitet.',
      ctaPrimary: 'Start gratis prøveuge',
      ctaSecondary: 'Bestil BPO-tjenester',
      trustBadge: 'Første uge gratis • Intet kreditkort • Annuller når som helst',
      microProof: ['24/7/365 dækning', 'Flersprogede teams (DA/EN/FR/ES + 8 flere)', '50-70% besparelse vs Europa/USA', 'Go-live på 7 dage', 'ISO 27001 • GDPR • PCI-DSS'],
      proofMetrics: [{ value: '200+', label: 'Kunder' }, { value: '500+', label: 'Agenter' }, { value: '29', label: 'Sprog' }, { value: '95%+', label: 'CSAT' }, { value: '99.9%', label: 'SLA' }, { value: '50-70%', label: 'Besparelse' }, { value: '7 Dage', label: 'Implementering' }],
      trustedBy: 'Betroet af 200+ virksomheder verden over',
      dialogTitle: 'Book et opdagelsesopkald',
    },
  },

  twoPillars: {
    en: {
      title: 'Two Pillars.',
      titleAccent: 'One Partner.',
      subtitle: 'Choose the path that fits your needs—or combine both for a complete solution.',
      pillar1: {
        title: 'Premium BPO / Contact Center',
        text: 'Customer Support, Tele-sales, Back-office, and Content Moderation—built for SLA, quality, and scalability.',
        bullets: ['Customer Support', 'Tele-sales', 'Back-office', 'Content Moderation'],
        cta: 'Explore BPO Solutions',
      },
      pillar2: {
        title: 'Digital Factory & Web Agency',
        text: 'High-performance websites, apps, AI automation, and CRM/helpdesk integrations—built to convert and scale.',
        bullets: ['Websites', 'Apps', 'AI automations', 'CRM/Helpdesk integrations'],
        cta: 'Explore Digital Factory',
      },
    },
    fr: {
      title: 'Deux piliers.',
      titleAccent: 'Un partenaire.',
      subtitle: 'Choisissez la voie qui correspond à vos besoins—ou combinez les deux pour une solution complète.',
      pillar1: {
        title: 'BPO Premium / Centre de contact',
        text: 'Support, télévente, back-office et modération — orientés SLA, qualité et scalabilité.',
        bullets: ['Support Client', 'Télévente', 'Back-office', 'Modération'],
        cta: 'Découvrir nos solutions BPO',
      },
      pillar2: {
        title: 'Usine Numérique & Agence Web',
        text: 'Sites et apps haute performance, automatisations IA, intégrations CRM/helpdesk — pensés conversion et croissance.',
        bullets: ['Sites web', 'Applications', 'Automatisations IA', 'Intégrations CRM/Helpdesk'],
        cta: 'Découvrir l\'Usine Numérique',
      },
    },
    es: {
      title: 'Dos pilares.',
      titleAccent: 'Un socio.',
      subtitle: 'Elige el camino que se adapte a tus necesidades—o combina ambos para una solución completa.',
      pillar1: {
        title: 'BPO Premium / Contact Center',
        text: 'Soporte, televentas, back-office y moderación — enfocado en SLA, calidad y escalabilidad.',
        bullets: ['Soporte al Cliente', 'Televentas', 'Back-office', 'Moderación'],
        cta: 'Ver soluciones BPO',
      },
      pillar2: {
        title: 'Digital Factory & Agencia Web',
        text: 'Webs y apps de alto rendimiento, automatización IA e integraciones CRM/helpdesk — para convertir y escalar.',
        bullets: ['Sitios web', 'Aplicaciones', 'Automatizaciones IA', 'Integraciones CRM/Helpdesk'],
        cta: 'Ver Digital Factory',
      },
    },
    ar: {
      title: 'ركيزتان.',
      titleAccent: 'شريك واحد.',
      subtitle: 'اختر المسار المناسب لاحتياجاتك — أو ادمج كليهما للحصول على حل متكامل.',
      pillar1: {
        title: 'BPO فاخر / مركز اتصال',
        text: 'دعم العملاء، مبيعات هاتفية، Back-office، ومراقبة محتوى — بجودة عالية وSLA صارم.',
        bullets: ['دعم العملاء', 'المبيعات الهاتفية', 'Back-office', 'مراقبة المحتوى'],
        cta: 'اكتشف حلول BPO',
      },
      pillar2: {
        title: 'Digital Factory & وكالة ويب',
        text: 'مواقع وتطبيقات عالية الأداء، أتمتة بالذكاء الاصطناعي، وتكاملات CRM/Helpdesk — لتحقيق تحويل أعلى ونمو أسرع.',
        bullets: ['مواقع ويب', 'تطبيقات', 'أتمتة بالذكاء الاصطناعي', 'تكاملات CRM/Helpdesk'],
        cta: 'اكتشف Digital Factory',
      },
    },
  },

  pilot: {
    en: {
      title: 'Launch a Pilot in',
      titleAccent: '7 Days',
      subtitle: 'Test our service with real tickets, real agents, and real KPIs—before you commit.',
      bullets: [
        'Scope + rollout plan in 24–48h',
        'Dedicated multilingual team setup',
        'KPI dashboard + weekly action plan',
      ],
      cta: 'Start the Pilot',
      note: 'No commitment required. See results first.',
      dialogTitle: 'Start Your 7-Day Pilot',
    },
    fr: {
      title: 'Lancer un pilote en',
      titleAccent: '7 jours',
      subtitle: 'Testez notre service avec de vrais tickets, de vrais agents et de vrais KPI — avant de vous engager.',
      bullets: [
        'Cadrage + plan de déploiement en 24–48h',
        'Mise en place d\'une équipe multilingue dédiée',
        'Dashboard KPI + plan d\'actions hebdo',
      ],
      cta: 'Démarrer le pilote',
      note: 'Aucun engagement requis. Voyez les résultats d\'abord.',
      dialogTitle: 'Démarrer votre pilote de 7 jours',
    },
    es: {
      title: 'Lanza un Piloto en',
      titleAccent: '7 Días',
      subtitle: 'Prueba nuestro servicio con tickets reales, agentes reales y KPIs reales — antes de comprometerte.',
      bullets: [
        'Alcance + plan en 24–48h',
        'Equipo multilingüe dedicado',
        'Dashboard KPI + plan semanal',
      ],
      cta: 'Empezar Piloto',
      note: 'Sin compromiso. Ve los resultados primero.',
      dialogTitle: 'Empieza tu Piloto de 7 días',
    },
    ar: {
      title: 'ابدأ تجربة خلال',
      titleAccent: '7 أيام',
      subtitle: 'اختبر خدمتنا بتذاكر حقيقية، ووكلاء حقيقيين، ومؤشرات أداء حقيقية — قبل الالتزام.',
      bullets: [
        'تحديد النطاق وخطة التنفيذ خلال 48 ساعة',
        'فريق متعدد اللغات مخصص',
        'لوحة مؤشرات KPI + خطة أسبوعية',
      ],
      cta: 'ابدأ التجربة',
      note: 'لا التزام مطلوب. شاهد النتائج أولاً.',
      dialogTitle: 'ابدأ تجربتك لمدة 7 أيام',
    },
  },

  services: {
    en: {
      badge: 'Our Services',
      title: 'Outcomes-Driven Solutions',
      subtitle: 'Every service is designed to deliver measurable results. Real KPIs, real impact.',
      viewAll: 'View All Services',
      viewService: 'View Service',
      items: [
        {
          title: 'Customer Support',
          outcome: 'Faster response, higher CSAT, multilingual coverage.',
          deliverables: ['Tier 1-3 multichannel support (voice, email, chat)', 'Ticket routing & escalation protocols', 'Knowledge base maintenance & macros'],
          kpis: 'CSAT, FRT, FCR',
        },
        {
          title: 'Tele-Sales',
          outcome: 'More qualified leads, higher conversion, predictable pipeline.',
          deliverables: ['Outbound campaigns & cold calling', 'Lead qualification & appointment setting', 'CRM updates & pipeline management'],
          kpis: 'Conversion rate, AOV, Lead-to-close',
        },
        {
          title: 'Back-Office',
          outcome: 'Accurate processing, strict SLA, scalable operations.',
          deliverables: ['Data entry & document processing', 'Order management & fulfillment', 'Invoice & payment reconciliation'],
          kpis: 'Accuracy, SLA, Throughput',
        },
        {
          title: 'Content Moderation',
          outcome: 'Fast TAT, consistent policies, safe user experience.',
          deliverables: ['User-generated content review', 'Trust & safety enforcement', 'Escalation & appeals handling'],
          kpis: 'TAT, Accuracy, Escalation rate',
        },
        {
          title: 'Web Development',
          outcome: 'Premium UI, SEO-ready, conversion-first builds.',
          deliverables: ['Custom web apps & landing pages', 'E-commerce & marketplace platforms', 'CMS & admin dashboard development'],
          kpis: 'Lighthouse score, SEO indexation, Conversion',
        },
        {
          title: 'Mobile Apps',
          outcome: 'Stable releases, clean UX, measurable retention.',
          deliverables: ['iOS & Android native/cross-platform apps', 'UI/UX design & prototyping', 'App store optimization & deployment'],
          kpis: 'Retention, Crash-free sessions, Time-to-release',
        },
        {
          title: 'AI Solutions',
          outcome: 'Automation, deflection, and cost-to-serve reduction.',
          deliverables: ['Chatbots & virtual agents', 'Workflow automation & RPA', 'Predictive analytics & ML models'],
          kpis: 'Automation rate, Deflection, Cost-to-serve',
        },
      ],
    },
    fr: {
      badge: 'Nos Services',
      title: 'Solutions Orientées Résultats',
      subtitle: 'Chaque service est conçu pour livrer des résultats mesurables. De vrais KPIs, un vrai impact.',
      viewAll: 'Voir tous les services',
      viewService: 'Voir le service',
      items: [
        {
          title: 'Support Client',
          outcome: 'Réponse plus rapide, CSAT plus élevé, couverture multilingue.',
          deliverables: ['Support multicanal Tier 1-3 (voix, email, chat)', 'Routage et protocoles d\'escalade', 'Maintenance base de connaissances & macros'],
          kpis: 'CSAT, FRT, FCR',
        },
        {
          title: 'Télévente',
          outcome: 'Plus de leads qualifiés, meilleure conversion, pipeline prévisible.',
          deliverables: ['Campagnes sortantes & cold calling', 'Qualification leads & prise de RDV', 'Mises à jour CRM & gestion pipeline'],
          kpis: 'Taux de conversion, AOV, Lead-to-close',
        },
        {
          title: 'Back-Office',
          outcome: 'Traitement précis, SLA strict, opérations scalables.',
          deliverables: ['Saisie de données & traitement documents', 'Gestion commandes & fulfillment', 'Rapprochement factures & paiements'],
          kpis: 'Précision, SLA, Débit',
        },
        {
          title: 'Modération de Contenu',
          outcome: 'TAT rapide, politiques cohérentes, expérience utilisateur sûre.',
          deliverables: ['Revue contenu généré utilisateur', 'Application trust & safety', 'Gestion escalades & appels'],
          kpis: 'TAT, Précision, Taux escalade',
        },
        {
          title: 'Développement Web',
          outcome: 'UI premium, SEO-ready, builds axés conversion.',
          deliverables: ['Apps web & landing pages sur mesure', 'Plateformes e-commerce & marketplace', 'Développement CMS & dashboard admin'],
          kpis: 'Score Lighthouse, Indexation SEO, Conversion',
        },
        {
          title: 'Applications Mobiles',
          outcome: 'Versions stables, UX épurée, rétention mesurable.',
          deliverables: ['Apps iOS & Android native/cross-platform', 'Design UI/UX & prototypage', 'Optimisation app store & déploiement'],
          kpis: 'Rétention, Sessions sans crash, Time-to-release',
        },
        {
          title: 'Solutions IA',
          outcome: 'Automatisation, déflection, réduction cost-to-serve.',
          deliverables: ['Chatbots & agents virtuels', 'Automatisation workflow & RPA', 'Analytics prédictive & modèles ML'],
          kpis: 'Taux automation, Déflection, Cost-to-serve',
        },
      ],
    },
    es: {
      badge: 'Nuestros Servicios',
      title: 'Soluciones Orientadas a Resultados',
      subtitle: 'Cada servicio está diseñado para entregar resultados medibles. KPIs reales, impacto real.',
      viewAll: 'Ver todos los servicios',
      viewService: 'Ver servicio',
      items: [
        {
          title: 'Soporte al Cliente',
          outcome: 'Respuesta más rápida, mayor CSAT, cobertura multilingüe.',
          deliverables: ['Soporte multicanal Tier 1-3 (voz, email, chat)', 'Enrutamiento y protocolos de escalado', 'Mantenimiento base conocimiento & macros'],
          kpis: 'CSAT, FRT, FCR',
        },
        {
          title: 'Televentas',
          outcome: 'Más leads cualificados, mayor conversión, pipeline predecible.',
          deliverables: ['Campañas outbound & cold calling', 'Cualificación leads & agenda citas', 'Actualizaciones CRM & gestión pipeline'],
          kpis: 'Tasa de conversión, AOV, Lead-to-close',
        },
        {
          title: 'Back-Office',
          outcome: 'Procesamiento preciso, SLA estricto, operaciones escalables.',
          deliverables: ['Entrada de datos & procesamiento documentos', 'Gestión pedidos & fulfillment', 'Conciliación facturas & pagos'],
          kpis: 'Precisión, SLA, Rendimiento',
        },
        {
          title: 'Moderación de Contenido',
          outcome: 'TAT rápido, políticas consistentes, experiencia de usuario segura.',
          deliverables: ['Revisión contenido generado por usuario', 'Aplicación trust & safety', 'Gestión escalados & apelaciones'],
          kpis: 'TAT, Precisión, Tasa escalado',
        },
        {
          title: 'Desarrollo Web',
          outcome: 'UI premium, SEO-ready, builds enfocados en conversión.',
          deliverables: ['Apps web & landing pages a medida', 'Plataformas e-commerce & marketplace', 'Desarrollo CMS & dashboard admin'],
          kpis: 'Score Lighthouse, Indexación SEO, Conversión',
        },
        {
          title: 'Apps Móviles',
          outcome: 'Versiones estables, UX limpia, retención medible.',
          deliverables: ['Apps iOS & Android nativas/multiplataforma', 'Diseño UI/UX & prototipado', 'Optimización app store & despliegue'],
          kpis: 'Retención, Sesiones sin crash, Time-to-release',
        },
        {
          title: 'Soluciones IA',
          outcome: 'Automatización, deflexión, reducción cost-to-serve.',
          deliverables: ['Chatbots & agentes virtuales', 'Automatización workflow & RPA', 'Analítica predictiva & modelos ML'],
          kpis: 'Tasa automatización, Deflexión, Cost-to-serve',
        },
      ],
    },
    ar: {
      badge: 'خدماتنا',
      title: 'حلول موجهة للنتائج',
      subtitle: 'كل خدمة مصممة لتقديم نتائج قابلة للقياس. مؤشرات أداء حقيقية، تأثير حقيقي.',
      viewAll: 'عرض جميع الخدمات',
      viewService: 'عرض الخدمة',
      items: [
        {
          title: 'دعم العملاء',
          outcome: 'استجابة أسرع، CSAT أعلى، تغطية متعددة اللغات.',
          deliverables: ['دعم متعدد القنوات Tier 1-3 (صوت، بريد، دردشة)', 'توجيه التذاكر وبروتوكولات التصعيد', 'صيانة قاعدة المعرفة والماكرو'],
          kpis: 'CSAT, FRT, FCR',
        },
        {
          title: 'المبيعات الهاتفية',
          outcome: 'المزيد من العملاء المحتملين المؤهلين، تحويل أعلى، خط أنابيب متوقع.',
          deliverables: ['حملات صادرة واتصال بارد', 'تأهيل العملاء المحتملين وتحديد المواعيد', 'تحديثات CRM وإدارة خط الأنابيب'],
          kpis: 'معدل التحويل، AOV، Lead-to-close',
        },
        {
          title: 'Back-Office',
          outcome: 'معالجة دقيقة، SLA صارم، عمليات قابلة للتوسع.',
          deliverables: ['إدخال البيانات ومعالجة المستندات', 'إدارة الطلبات والتنفيذ', 'تسوية الفواتير والمدفوعات'],
          kpis: 'الدقة، SLA، الإنتاجية',
        },
        {
          title: 'مراقبة المحتوى',
          outcome: 'TAT سريع، سياسات متسقة، تجربة مستخدم آمنة.',
          deliverables: ['مراجعة المحتوى المُنشأ من المستخدم', 'تطبيق الثقة والسلامة', 'معالجة التصعيدات والاستئنافات'],
          kpis: 'TAT، الدقة، معدل التصعيد',
        },
        {
          title: 'تطوير الويب',
          outcome: 'واجهة مستخدم متميزة، جاهز لـ SEO، بناء موجه للتحويل.',
          deliverables: ['تطبيقات ويب وصفحات هبوط مخصصة', 'منصات التجارة الإلكترونية والسوق', 'تطوير CMS ولوحة التحكم'],
          kpis: 'نتيجة Lighthouse، فهرسة SEO، التحويل',
        },
        {
          title: 'تطبيقات الموبايل',
          outcome: 'إصدارات مستقرة، UX نظيفة، احتفاظ قابل للقياس.',
          deliverables: ['تطبيقات iOS و Android أصلية/متعددة المنصات', 'تصميم UI/UX والنماذج الأولية', 'تحسين متجر التطبيقات والنشر'],
          kpis: 'الاحتفاظ، الجلسات بدون أعطال، وقت الإصدار',
        },
        {
          title: 'حلول الذكاء الاصطناعي',
          outcome: 'أتمتة، انحراف، وتقليل تكلفة الخدمة.',
          deliverables: ['روبوتات الدردشة والوكلاء الافتراضيون', 'أتمتة سير العمل و RPA', 'التحليلات التنبؤية ونماذج ML'],
          kpis: 'معدل الأتمتة، الانحراف، تكلفة الخدمة',
        },
      ],
    },
  },

  process: {
    en: {
      badge: 'Our Process',
      title: 'How We Deliver Excellence',
      subtitle: 'A proven methodology that minimizes risk and maximizes outcomes.',
      pilotCta: '7-Day Pilot',
      pilotSub: 'Start with a real pilot. See real results before you commit.',
      zeroRisk: 'Zero Risk',
      steps: [
        { title: 'Discover', duration: 'Week 1', description: 'Deep dive into your operations.', details: ['Goals & success metrics', 'Volumes & patterns', 'Languages & time zones', 'Tools & integrations'] },
        { title: 'Pilot', duration: '7 Days', description: 'Launch with a dedicated team.', details: ['Workflows & scripts', 'Agent onboarding', 'QA baseline setup', 'Real ticket handling'], highlight: true },
        { title: 'Ramp', duration: 'Week 2-4', description: 'Scale based on results.', details: ['Hiring & training', 'Shift scheduling', 'Capacity planning', 'Performance targets'] },
        { title: 'QA', duration: 'Ongoing', description: 'Continuous quality assurance.', details: ['Scorecards & rubrics', 'Weekly calibrations', 'Agent coaching', 'CSAT tracking'] },
        { title: 'Optimize', duration: 'Monthly', description: 'Data-driven improvements.', details: ['Knowledge base updates', 'Macros & templates', 'Automation rules', 'Process refinement'] },
        { title: 'Report', duration: 'Weekly', description: 'Transparent dashboards.', details: ['KPI dashboards', 'Executive summaries', 'Action plans', 'Business reviews'] },
      ],
    },
    fr: {
      badge: 'Notre Méthode',
      title: 'Comment Nous Livrons l\'Excellence',
      subtitle: 'Une méthodologie éprouvée qui minimise les risques et maximise les résultats.',
      pilotCta: 'Pilote 7 Jours',
      pilotSub: 'Commencez par un vrai pilote. Voyez de vrais résultats avant de vous engager.',
      zeroRisk: 'Zéro Risque',
      steps: [
        { title: 'Découverte', duration: 'Semaine 1', description: 'Analyse approfondie de vos opérations.', details: ['Objectifs & critères de succès', 'Volumes & patterns', 'Langues & fuseaux horaires', 'Outils & intégrations'] },
        { title: 'Pilote', duration: '7 Jours', description: 'Lancement avec équipe dédiée.', details: ['Workflows & scripts', 'Onboarding agents', 'Baseline QA', 'Traitement tickets réels'], highlight: true },
        { title: 'Montée en charge', duration: 'Semaine 2-4', description: 'Scaling basé sur résultats.', details: ['Recrutement & formation', 'Planning shifts', 'Planification capacité', 'Objectifs performance'] },
        { title: 'QA', duration: 'Continu', description: 'Assurance qualité continue.', details: ['Grilles & rubriques', 'Calibrations hebdo', 'Coaching agents', 'Suivi CSAT'] },
        { title: 'Optimisation', duration: 'Mensuel', description: 'Améliorations data-driven.', details: ['Mises à jour base connaissance', 'Macros & templates', 'Règles automation', 'Affinage process'] },
        { title: 'Reporting', duration: 'Hebdo', description: 'Dashboards transparents.', details: ['Dashboards KPI', 'Résumés exécutifs', 'Plans d\'action', 'Revues business'] },
      ],
    },
    es: {
      badge: 'Nuestro Proceso',
      title: 'Cómo Entregamos Excelencia',
      subtitle: 'Una metodología probada que minimiza riesgos y maximiza resultados.',
      pilotCta: 'Piloto 7 Días',
      pilotSub: 'Empieza con un piloto real. Ve resultados reales antes de comprometerte.',
      zeroRisk: 'Cero Riesgo',
      steps: [
        { title: 'Descubrir', duration: 'Semana 1', description: 'Análisis profundo de tus operaciones.', details: ['Objetivos & métricas de éxito', 'Volúmenes & patrones', 'Idiomas & zonas horarias', 'Herramientas & integraciones'] },
        { title: 'Piloto', duration: '7 Días', description: 'Lanzamiento con equipo dedicado.', details: ['Workflows & scripts', 'Onboarding agentes', 'Baseline QA', 'Manejo tickets reales'], highlight: true },
        { title: 'Rampa', duration: 'Semana 2-4', description: 'Escalar según resultados.', details: ['Contratación & formación', 'Programación turnos', 'Planificación capacidad', 'Objetivos rendimiento'] },
        { title: 'QA', duration: 'Continuo', description: 'Aseguramiento calidad continuo.', details: ['Scorecards & rúbricas', 'Calibraciones semanales', 'Coaching agentes', 'Seguimiento CSAT'] },
        { title: 'Optimizar', duration: 'Mensual', description: 'Mejoras basadas en datos.', details: ['Actualizaciones base conocimiento', 'Macros & plantillas', 'Reglas automatización', 'Refinamiento proceso'] },
        { title: 'Reportar', duration: 'Semanal', description: 'Dashboards transparentes.', details: ['Dashboards KPI', 'Resúmenes ejecutivos', 'Planes de acción', 'Revisiones negocio'] },
      ],
    },
    ar: {
      badge: 'عمليتنا',
      title: 'كيف نقدم التميز',
      subtitle: 'منهجية مثبتة تقلل المخاطر وتعظم النتائج.',
      pilotCta: 'تجربة 7 أيام',
      pilotSub: 'ابدأ بتجربة حقيقية. شاهد نتائج حقيقية قبل الالتزام.',
      zeroRisk: 'صفر مخاطر',
      steps: [
        { title: 'اكتشاف', duration: 'الأسبوع 1', description: 'تحليل عميق لعملياتك.', details: ['الأهداف ومعايير النجاح', 'الأحجام والأنماط', 'اللغات والمناطق الزمنية', 'الأدوات والتكاملات'] },
        { title: 'تجربة', duration: '7 أيام', description: 'إطلاق مع فريق مخصص.', details: ['سير العمل والنصوص', 'إعداد الوكلاء', 'خط أساس QA', 'التعامل مع التذاكر الحقيقية'], highlight: true },
        { title: 'توسيع', duration: 'الأسبوع 2-4', description: 'التوسع بناءً على النتائج.', details: ['التوظيف والتدريب', 'جدولة المناوبات', 'تخطيط القدرات', 'أهداف الأداء'] },
        { title: 'ضمان الجودة', duration: 'مستمر', description: 'ضمان جودة مستمر.', details: ['بطاقات الأداء والمعايير', 'المعايرات الأسبوعية', 'تدريب الوكلاء', 'تتبع CSAT'] },
        { title: 'تحسين', duration: 'شهري', description: 'تحسينات مدفوعة بالبيانات.', details: ['تحديثات قاعدة المعرفة', 'الماكرو والقوالب', 'قواعد الأتمتة', 'تحسين العملية'] },
        { title: 'التقارير', duration: 'أسبوعي', description: 'لوحات معلومات شفافة.', details: ['لوحات KPI', 'الملخصات التنفيذية', 'خطط العمل', 'مراجعات الأعمال'] },
      ],
    },
  },

  security: {
    en: {
      badge: 'Enterprise Security',
      title: 'Security & Compliance by Design',
      subtitle: 'Your data is our responsibility. We implement bank-grade security measures and maintain compliance with international standards.',
      items: [
        { title: 'Data Handling', description: 'Least privilege, controlled access, secure workflows' },
        { title: 'Access Controls', description: 'Role-based permissions + device policies' },
        { title: 'NDA & Confidentiality', description: 'Contractual guarantees + strict processes' },
        { title: 'Quality Monitoring', description: 'Daily QA + weekly reporting' },
        { title: 'GDPR Readiness', description: 'Privacy-first operations aligned with GDPR principles' },
      ],
      certifications: ['ISO 27001 Aligned', 'PCI DSS Ready', 'SOC 2 Ready', 'HIPAA Ready'],
    },
    fr: {
      badge: 'Sécurité Entreprise',
      title: 'Sécurité & Conformité dès la Conception',
      subtitle: 'Vos données sont notre responsabilité. Nous appliquons des mesures de sécurité bancaire et maintenons la conformité avec les standards internationaux.',
      items: [
        { title: 'Données', description: 'Accès minimaux, workflows sécurisés' },
        { title: 'Contrôles', description: 'Rôles, permissions, politiques appareils' },
        { title: 'NDA', description: 'Confidentialité contractuelle + process stricts' },
        { title: 'Qualité', description: 'QA quotidien + reporting hebdo' },
        { title: 'RGPD', description: 'Principes privacy-first alignés RGPD' },
      ],
      certifications: ['ISO 27001 Aligné', 'PCI DSS Prêt', 'SOC 2 Prêt', 'HIPAA Ready'],
    },
    es: {
      badge: 'Seguridad Empresarial',
      title: 'Seguridad & Cumplimiento por Diseño',
      subtitle: 'Tus datos son nuestra responsabilidad. Implementamos medidas de seguridad de nivel bancario y mantenemos cumplimiento con estándares internacionales.',
      items: [
        { title: 'Manejo de Datos', description: 'Privilegio mínimo, acceso controlado, workflows seguros' },
        { title: 'Controles de Acceso', description: 'Permisos basados en roles + políticas de dispositivos' },
        { title: 'NDA & Confidencialidad', description: 'Garantías contractuales + procesos estrictos' },
        { title: 'Monitoreo de Calidad', description: 'QA diario + reportes semanales' },
        { title: 'Preparación GDPR', description: 'Operaciones privacy-first alineadas con principios GDPR' },
      ],
      certifications: ['ISO 27001 Alineado', 'PCI DSS Listo', 'SOC 2 Listo', 'HIPAA Ready'],
    },
    ar: {
      badge: 'أمان المؤسسات',
      title: 'الأمان والامتثال حسب التصميم',
      subtitle: 'بياناتك مسؤوليتنا. نطبق إجراءات أمان على مستوى البنوك ونحافظ على الامتثال للمعايير الدولية.',
      items: [
        { title: 'معالجة البيانات', description: 'صلاحيات محدودة، وصول مُتحكم، سير عمل آمن' },
        { title: 'ضوابط الوصول', description: 'صلاحيات قائمة على الأدوار + سياسات الأجهزة' },
        { title: 'NDA والسرية', description: 'ضمانات تعاقدية + عمليات صارمة' },
        { title: 'مراقبة الجودة', description: 'QA يومي + تقارير أسبوعية' },
        { title: 'جاهزية GDPR', description: 'عمليات تعطي الأولوية للخصوصية متوافقة مع مبادئ GDPR' },
      ],
      certifications: ['ISO 27001 متوافق', 'PCI DSS جاهز', 'SOC 2 جاهز', 'HIPAA Ready'],
    },
  },

  finalCta: {
    en: {
      title: 'Ready to Scale Support, Sales, or Delivery—Fast?',
      subtitle: 'Tell us your volumes and languages. We\'ll propose a pilot plan within 48 hours.',
      cta1: 'Book a Call',
      cta2: 'Get a Quote',
      bookCard: {
        title: 'Book a Discovery Call',
        description: '30-minute call to discuss your needs, explore solutions, and get a custom quote.',
        cta: 'Schedule Now',
      },
      whatsappCard: {
        title: 'Chat on WhatsApp',
        description: 'Quick questions? Get instant answers from our team via WhatsApp.',
        cta: 'Start Chat',
      },
      formTitle: 'Quick Contact',
      formFields: {
        name: 'Name',
        namePlaceholder: 'Your name',
        email: 'Email',
        emailPlaceholder: 'your@email.com',
        service: 'Service',
        servicePlaceholder: 'Select service',
        languages: 'Languages Needed',
        languagesPlaceholder: 'Select languages',
        message: 'Message',
        messagePlaceholder: 'Tell us about your project...',
        submit: 'Send Message',
      },
    },
    fr: {
      title: 'Prêt à scaler votre Support, votre Vente ou votre Delivery — rapidement ?',
      subtitle: 'Donnez vos volumes et langues. On vous propose un plan pilote sous 48h.',
      cta1: 'Réserver un appel',
      cta2: 'Demander un devis',
      bookCard: {
        title: 'Réserver un appel de découverte',
        description: 'Appel de 30 minutes pour discuter de vos besoins, explorer les solutions et obtenir un devis personnalisé.',
        cta: 'Planifier maintenant',
      },
      whatsappCard: {
        title: 'Discuter sur WhatsApp',
        description: 'Questions rapides ? Obtenez des réponses instantanées de notre équipe via WhatsApp.',
        cta: 'Démarrer le chat',
      },
      formTitle: 'Contact Rapide',
      formFields: {
        name: 'Nom',
        namePlaceholder: 'Votre nom',
        email: 'Email',
        emailPlaceholder: 'votre@email.com',
        service: 'Service',
        servicePlaceholder: 'Sélectionner un service',
        languages: 'Langues Nécessaires',
        languagesPlaceholder: 'Sélectionner les langues',
        message: 'Message',
        messagePlaceholder: 'Parlez-nous de votre projet...',
        submit: 'Envoyer le message',
      },
    },
    es: {
      title: '¿Listo para escalar soporte, ventas o delivery—rápido?',
      subtitle: 'Dinos volumen e idiomas. Te proponemos un plan de piloto en 48h.',
      cta1: 'Reservar una llamada',
      cta2: 'Solicitar presupuesto',
      bookCard: {
        title: 'Reservar una llamada de descubrimiento',
        description: 'Llamada de 30 minutos para discutir tus necesidades, explorar soluciones y obtener un presupuesto personalizado.',
        cta: 'Agendar ahora',
      },
      whatsappCard: {
        title: 'Chatea en WhatsApp',
        description: '¿Preguntas rápidas? Obtén respuestas instantáneas de nuestro equipo vía WhatsApp.',
        cta: 'Iniciar chat',
      },
      formTitle: 'Contacto Rápido',
      formFields: {
        name: 'Nombre',
        namePlaceholder: 'Tu nombre',
        email: 'Email',
        emailPlaceholder: 'tu@email.com',
        service: 'Servicio',
        servicePlaceholder: 'Seleccionar servicio',
        languages: 'Idiomas Necesarios',
        languagesPlaceholder: 'Seleccionar idiomas',
        message: 'Mensaje',
        messagePlaceholder: 'Cuéntanos sobre tu proyecto...',
        submit: 'Enviar mensaje',
      },
    },
    ar: {
      title: 'جاهز لتوسيع الدعم أو المبيعات أو التسليم بسرعة؟',
      subtitle: 'أخبرنا بالحجم واللغات، ونقترح خطة تجربة خلال 48 ساعة.',
      cta1: 'احجز مكالمة',
      cta2: 'اطلب عرض سعر',
      bookCard: {
        title: 'احجز مكالمة استكشافية',
        description: 'مكالمة 30 دقيقة لمناقشة احتياجاتك، واستكشاف الحلول، والحصول على عرض أسعار مخصص.',
        cta: 'جدول الآن',
      },
      whatsappCard: {
        title: 'الدردشة عبر واتساب',
        description: 'أسئلة سريعة؟ احصل على إجابات فورية من فريقنا عبر واتساب.',
        cta: 'بدء الدردشة',
      },
      formTitle: 'اتصال سريع',
      formFields: {
        name: 'الاسم',
        namePlaceholder: 'اسمك',
        email: 'البريد الإلكتروني',
        emailPlaceholder: 'بريدك@email.com',
        service: 'الخدمة',
        servicePlaceholder: 'اختر خدمة',
        languages: 'اللغات المطلوبة',
        languagesPlaceholder: 'اختر اللغات',
        message: 'الرسالة',
        messagePlaceholder: 'أخبرنا عن مشروعك...',
        submit: 'إرسال الرسالة',
      },
    },
  },

  faq: {
    en: {
      badge: 'FAQ',
      title: 'Frequently Asked Questions',
      subtitle: 'Everything you need to know about partnering with Call IT Dev.',
      items: [
        { q: 'How fast can you start?', a: 'We can launch a pilot in 7 days. A rollout plan is shared within 24–48h after the discovery call.' },
        { q: 'Which languages do you cover?', a: 'EN/FR/ES/AR plus additional languages depending on your needs and volume.' },
        { q: 'Do you operate 24/7?', a: 'Yes—24/7/365 coverage with flexible schedules and escalation rules.' },
        { q: 'What tools do you integrate with?', a: 'Zendesk, Freshdesk, Salesforce, HubSpot, Intercom, Jira, and custom stacks.' },
        { q: 'How do you ensure quality?', a: 'Daily QA, calibrations, weekly reporting, and continuous improvement plans.' },
        { q: 'How do you price?', a: 'Per hour, per ticket, per lead, or hybrid—depending on scope and SLAs.' },
        { q: 'Can we start with a pilot?', a: 'Yes. A pilot validates KPIs, workflows, and scaling before full ramp.' },
        { q: 'How do you handle data security?', a: 'NDA, least-privilege access, device policies, and secure processes.' },
      ],
    },
    fr: {
      badge: 'FAQ',
      title: 'Questions Fréquentes',
      subtitle: 'Tout ce que vous devez savoir pour devenir partenaire Call IT Dev.',
      items: [
        { q: 'À quelle vitesse pouvez-vous démarrer ?', a: 'Pilote possible en 7 jours. Plan de déploiement communiqué sous 24–48h après l\'appel.' },
        { q: 'Quelles langues couvrez-vous ?', a: 'FR/EN/ES/AR + d\'autres selon vos besoins et volumes.' },
        { q: 'Faites-vous du 24/7 ?', a: 'Oui, 24/7/365 avec planning flexible et règles d\'escalade.' },
        { q: 'Avec quels outils vous intégrez-vous ?', a: 'Zendesk, Freshdesk, Salesforce, HubSpot, Intercom, Jira, etc.' },
        { q: 'Comment garantissez-vous la qualité ?', a: 'QA quotidien, calibrations, reporting hebdo, plans d\'amélioration.' },
        { q: 'Quels sont vos modèles de pricing ?', a: 'À l\'heure, au ticket, au lead, ou hybride selon scope et SLA.' },
        { q: 'Peut-on commencer par un pilote ?', a: 'Oui, pour valider KPIs, process et montée en charge.' },
        { q: 'Sécurité des données ?', a: 'NDA, accès minimaux, politiques appareils, process sécurisés.' },
      ],
    },
    es: {
      badge: 'FAQ',
      title: 'Preguntas Frecuentes',
      subtitle: 'Todo lo que necesitas saber para asociarte con Call IT Dev.',
      items: [
        { q: '¿Qué tan rápido pueden empezar?', a: 'Podemos lanzar un piloto en 7 días. Plan en 24–48h tras la llamada.' },
        { q: '¿Qué idiomas cubren?', a: 'ES/EN/FR/AR + otros según volumen.' },
        { q: '¿Trabajan 24/7?', a: 'Sí, 24/7/365 con escalados definidos.' },
        { q: '¿Con qué herramientas integran?', a: 'Zendesk, Freshdesk, Salesforce, HubSpot, Intercom, Jira, etc.' },
        { q: '¿Cómo aseguran la calidad?', a: 'QA diario, calibraciones y reportes semanales.' },
        { q: '¿Cómo es el pricing?', a: 'Por hora, por ticket, por lead o híbrido.' },
        { q: '¿Podemos empezar con piloto?', a: 'Sí, para validar KPIs y escalar.' },
        { q: '¿Seguridad de datos?', a: 'NDA, accesos mínimos, políticas de dispositivos y procesos seguros.' },
      ],
    },
    ar: {
      badge: 'الأسئلة الشائعة',
      title: 'الأسئلة المتكررة',
      subtitle: 'كل ما تحتاج معرفته للشراكة مع Call IT Dev.',
      items: [
        { q: 'متى يمكنكم البدء؟', a: 'يمكننا إطلاق تجربة خلال 7 أيام، وخطة التنفيذ خلال 48 ساعة بعد مكالمة الاكتشاف.' },
        { q: 'ما اللغات المتاحة؟', a: 'العربية/الفرنسية/الإنجليزية/الإسبانية + لغات إضافية حسب الحاجة.' },
        { q: 'هل تعملون 24/7؟', a: 'نعم، تغطية 24/7/365 مع قواعد تصعيد واضحة.' },
        { q: 'ما الأدوات التي تتكاملون معها؟', a: 'Zendesk وFreshdesk وSalesforce وHubSpot وIntercom وJira وغيرها.' },
        { q: 'كيف تضمنون الجودة؟', a: 'QA يومي، معايرات، وتقارير أسبوعية مع تحسين مستمر.' },
        { q: 'كيف يكون التسعير؟', a: 'بالساعة أو بالتذكرة أو بالـLead أو نموذج هجين.' },
        { q: 'هل يمكن البدء بتجربة؟', a: 'نعم، لتأكيد KPIs والعمليات قبل التوسع.' },
        { q: 'كيف تتعاملون مع أمان البيانات؟', a: 'NDA، صلاحيات وصول محدودة، سياسات أجهزة، وعمليات آمنة.' },
      ],
    },
  },
};

export function getHomeContent<T extends keyof typeof homeContent>(
  section: T,
  lang: string
): (typeof homeContent)[T]['en'] {
  const sectionData = homeContent[section] as Record<string, (typeof homeContent)[T]['en']>;
  if (sectionData[lang]) {
    return sectionData[lang];
  }
  return sectionData['en'];
}
